import { render, staticRenderFns } from "./OrderReports.vue?vue&type=template&id=34e2514c&scoped=true"
import script from "./OrderReports.vue?vue&type=script&lang=js"
export * from "./OrderReports.vue?vue&type=script&lang=js"
import style0 from "./OrderReports.vue?vue&type=style&index=0&id=34e2514c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2514c",
  null
  
)

export default component.exports